/*@flow*/
import * as t from 'lib/t';

export default t.subtype(t.Array, v => v && v.length > 0, 'NonEmptyArray');
